import $ from 'jquery';

const $document = $(document);
const studyProgramBlockContentEl = $('.study-program-block__content');

$(function () {
    if (studyProgramBlockContentEl.length > 0) {
        studyProgramBlockContentEl.each(function () {
            studyProgramBlockContent($(this));
        });
    }
});

const studyProgramBlockContent = element => {
    
    bindStudyProgramSwitcher(element);
};

const bindStudyProgramSwitcher = (element) => {
    element.on('click', '.study-program-item__info-block-switcher', function () {
        const $thisEl = $(this);
        var itemTags = $thisEl.parent().parent().parent();
        var infoBlock = itemTags.find('.study-program-item__info-block')[0];
        if ($thisEl.hasClass('close')) {
            $thisEl.removeClass('close').addClass('open');
            $(infoBlock).removeClass('close').addClass('open');;
        } else {
            $thisEl.removeClass('open').addClass('close');
            $(infoBlock).removeClass('open').addClass('close');
        }
    });
};